import { EaSkillData } from "src/models/skill/skill.model";
import { useEffect, useState } from "react";
import CompetenceBMItem from "./CompetenceBMItem";

function CompetenceBM(props) {
    const [skillsData, setSkillsData] = useState<EaSkillData[]>(props.skillsData);
    useEffect(() => {
        if (props.skillsData != undefined) {
            setSkillsData(props.skillsData);
        }
    }, [props.skillsData]);

    useEffect(() => {
        props.setData(skillsData)
    }, [skillsData]);

    const onBlur = (obj) => {
        setSkillsData(all =>
            all.map(data => {
                if (data.id === obj.id) {
                    return obj;
                }
                return data;
            })
        );
    }
    return (
        <>
            {
                skillsData.map(item => {
                    return <CompetenceBMItem idBusinessManager={props.idBusinessManager} key={item.id} skill={item} onBlur={onBlur} />
                })
            }
        </>
    );
}

export default CompetenceBM;